<template>
  <div class="hello">
    <van-card
      v-if="isSign"
      :desc="signInfo.gender == '1' ? '男' : '女'"
      :title="signInfo.residentName"
      :thumb="avatarImg"
    >
      <template #tags>
        <van-tag plain type="success">已签约</van-tag>
        <div class="tagbox">
          <span>签约机构：{{ signInfo.orgName }}</span>
          <span>签约团队：{{ signInfo.teamName }}</span>
          <span>签约医生：{{ signInfo.userName }}</span>
        </div>
      </template>
    </van-card>
    <van-card v-else :thumb="avatarImg">
      <template #tags>
        <p style="font-size: 16px;">{{ realInfo.certName }}</p>
        <van-tag plain type="danger" v-if="!signInfo.signApplyMsg"
          >未签约</van-tag
        >
        <van-tag plain type="danger" v-if="signInfo.signApplyMsg">{{
          signInfo.signApplyMsg
        }}</van-tag>
      </template>
    </van-card>
    <van-empty description="未查询到签约信息" v-show="!isSign"> </van-empty>
    <van-button
      v-if="signCode == 4 || signCode == 0"
      round
      plain
      type="primary"
      id="btn"
      @click="handleClick"
    >
      {{ isSign ? "查看签约详情" : "去签约" }}
    </van-button>
    <van-button
      v-if="signCode == 200 || signCode == 500"
      round
      plain
      type="primary"
      id="btn"
      @click="handleClick"
    >
      {{ isSign ? "查看签约详情" : "去签约" }}
    </van-button>
  </div>
</template>

<script>
import { Card, Tag, Button, Empty } from "vant";
import avatarImg from "@/assets/img/tx.png";

export default {
  name: "HelloWorld",
  components: {
    [Card.name]: Card,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Empty.name]: Empty,
  },
  props: {
    signInfo: {
      type: Object,
      default: () => {},
    },
    isSign: {
      type: Boolean,
      default: () => false,
    },
    realInfo: {
      type: Object,
      default: () => {},
    },
    signCode: {
      type: Number,
      default: () => null,
    },
  },
  data() {
    return {
      avatarImg: avatarImg,
    };
  },
  methods: {
    handleClick() {
      this.$emit("viewDetail");
    },
  },
};
</script>

<style scoped>
.van-card {
  border-radius: 5px;
  padding: 20px 15px;
}
.van-card__title {
  font-size: 16px;
}
.van-card__desc {
  font-size: 14px;
  margin: 5px 0;
}
.van-card__content {
  text-align: left;
}
.van-tag--plain {
  font-size: 14px;
  padding: 4px 4px;
}
.van-empty {
  padding: 0;
}
.hello {
  padding-top: 30px;
}
.tagbox {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  line-height: 25px;
  font-size: 15px;
}
#btn {
  margin-top: 20px;
  min-width: 160px;
}
</style>
